import { ref } from 'vue'

// gridApi is kept in its own file to avoid a circular dependency.
// useAgGrid.js imports from CardStore, and CardStore needs gridApi —
// if gridApi were defined in useAgGrid.js, that would create a cycle.
// By isolating it here (no other imports), both useAgGrid and any store
// can safely import it without triggering circular module initialization.
export const gridApi = ref(null)
